module.exports = __webpack_public_path__ + "static/media/nima_walk.ce58d45d.gif";